// extracted by mini-css-extract-plugin
export default {"link":"link-px9kAK","icon":"icon-hwh2Ix","text":"text-_hvIad","discord":"discord-cDnuiz","twitter":"twitter-ALajOI"};